export function PageHeader({ title, subtitle }: { title: string; subtitle?: string }) {
  return (
    <header className="mb-6">
      <h1 className="font-display font-bold tracking-hs-tight text-[27px] leading-tight text-hs-text">
        {title}
      </h1>
      {subtitle && <p className="mt-1 text-[14px] text-hs-text-mute">{subtitle}</p>}
    </header>
  );
}
